import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosOtrosListaItemNumerochequeComponent {
  data
  onClose
  cheque_numero = null
  actualizando = false

  constructor (NominaPagosPagoFolio) {
    this.NominaPagosPagoFolio = NominaPagosPagoFolio
  }

  actualizar () {
    if (this.actualizando) return
    this.actualizando = true

    let data = {
      id_cuenta_retiro: this.data.id_cuenta_retiro,
      cheque_numero: this.cheque_numero,
    }

    this.NominaPagosPagoFolio.put(this.data.id_nomina, this.data.id_empresa, this.data.id_empleado, this.data.indice, data)
      .then(() => {
        this.data.cheque_numero = this.cheque_numero
        this.onClose()
      })
      .finally(() => (this.actualizando = false))
  }

  cancelar () {
    this.onClose()
  }
}

module.component('nominasNominaDispersionPagosOtrosListaItemNumerocheque', {
  controller: NominasNominaDispersionPagosOtrosListaItemNumerochequeComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/otros/lista/item/numerocheque/component.js